import React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import {useCurrentUser} from 'src/hooks/useCurrentUser';
import {usePageTitle} from 'src/hooks/usePageTitle';

import BoxLoading from '@pb/kit-component-box-loading';
import Group from '@pb/kit-component-group';
import Tabs, {Tab} from '@pb/kit-component-tabs-v2';
import Typography from '@pb/kit-component-typography';

import {ProfileTabSeparator} from '../main/components/separator/profile-tab-separator';

import {VendorAdminRouter} from './vendor-admin-router';

export const VendorAdminLendingPage = () => {
    usePageTitle('Client Portal: Entitlement Vendor Portal');
    const navigate = useNavigate();
    const location = useLocation();
    const {currentUser} = useCurrentUser();
    const loading = false;
    const vendorName = currentUser?.vendor?.vendorName || '';
    const getActiveTab = () => {
        const path = location.pathname.split('/')[2];
        return path || 'pending';
    };

    const activeTab = getActiveTab();

    const handleTabClick = (tab: string) => {
        navigate(`/vendor-admin/${tab}`);
    };

    return (
        <Group direction="v" gap="xxs">
            <Group style={{padding: 16, paddingBottom: 0}} direction="v" gap="xs">
                <Typography
                    style={{borderBottom: '2px solid #eee', paddingBottom: 12}}
                    variant="heading-level-1">
                    { vendorName ? `Entitlement access requests for ${vendorName}` : 'Entitlement access requests' }
                </Typography>
            </Group>
            <Group style={{paddingLeft: 16}} direction="v" gap="xxs">
                <Tabs tabsId="vendor-admin-requests-tabs" tabPanelId="vendor-admin-requests-panel" value={activeTab}>
                    <Tab value="pending" caption="Pending" onClick={() => handleTabClick('pending')}/>
                    <Tab value="approved" caption="Approved" onClick={() => handleTabClick('approved')}/>
                    <Tab value="denied" caption="Denied" onClick={() => handleTabClick('denied')}/>
                    <Tab value="all" caption="All Requests" onClick={() => handleTabClick('all')}/>
                </Tabs>
                <ProfileTabSeparator/>
            </Group>
            <BoxLoading loading={loading}>
                <VendorAdminRouter/>
            </BoxLoading>
        </Group>
    );
};
